import { Routes, mapToCanActivate } from '@angular/router';
import { LocationGuard } from '@next/core-lib/relationships';

import { ArrivalOverviewComponent } from './components/arrival-overview/arrival-overview.component';
import { CycleAddComponent } from './components/cycle-add/cycle-add.component';
import { CycleItemComponent } from './components/cycle-item/cycle-item.component';
import { CycleOverviewComponent } from './components/cycle-overview/cycle-overview.component';
import { DepartureOverviewComponent } from './components/departure-overview/departure-overview.component';
import { GeneralComponent } from './components/general/general.component';
import { MovementOverviewComponent } from './components/movement-overview/movement-overview.component';
import { OrderOverviewComponent } from './components/order-overview/order-overview.component';
import { ReportsComponent } from './components/reports/reports.component';
import { SectionOverviewComponent } from './components/section-overview/section-overview.component';
import { CyclesGuard } from './guards/cycles.guard';

export const cycleRoutes: Routes = [
  {
    path: '',
    component: CycleOverviewComponent,
    canActivate: mapToCanActivate([LocationGuard, CyclesGuard]),
    data: { name: 'cycle-overview' },
  },
  {
    path: 'add',
    component: CycleAddComponent,
    canActivate: mapToCanActivate([LocationGuard, CyclesGuard]),
    children: [
      {
        path: '',
        component: GeneralComponent,
        canActivate: mapToCanActivate([LocationGuard, CyclesGuard]),
        data: { name: 'general' },
      },
    ],
  },
  {
    path: ':cycleId',
    component: CycleItemComponent,
    canActivate: mapToCanActivate([LocationGuard, CyclesGuard]),
    children: [
      {
        path: '',
        component: GeneralComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'general' },
      },
      {
        path: 'section',
        component: SectionOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'section' },
      },
      {
        path: 'orders',
        component: OrderOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'orders' },
      },
      {
        path: 'arrivals',
        component: ArrivalOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'arrivals' },
      },
      {
        path: 'movements',
        component: MovementOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'movements' },
      },
      {
        path: 'departures',
        component: DepartureOverviewComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'departures' },
      },
      {
        path: 'reports',
        component: ReportsComponent,
        canActivate: mapToCanActivate([LocationGuard]),
        data: { name: 'reports' },
      },
    ],
  },
];
